<template>
  <div class="height">
      <div class="ask-bac">
        <vue-header title="问诊" :fixed="tyle==1?true:false"/>
        <div>
            <div class="ask-box" v-for="( item, index ) in problem.data" v-bind:key="index">
              <div v-if="index==page">
                  <div v-if="item.content">
                  <div class="ask-num flex">
                      <!-- <div class="flex-1"></div>
                      <div><span>{{page+1>10?page+1:`0${page+1}`}}</span> / {{problem.data.length>9?problem.data.length:`0${problem.data.length}`}}</div> -->
                  </div>
                  <div class="ask-problem">{{item.title}}
                    <div class="ask-width" v-if="!item.is_single">
                      <div class="ask-choice">多选</div>
                    </div>
                  </div>
                  <div v-if="item.no_select">
                      <div class="ask-year flex" v-if="item.id!==-2">
                          <div class="ask-time short" :class="{ idcard: item.long }" >{{item.content[0]}}</div>
                          <div>{{item.unit}}</div>
                      </div>
                      <div class="ask-year flex" v-else>
                        <div class="ask-time year" :class="{ active: item.date==0 }" @click="itemFun(0,index)">{{item.content[0]}}</div>
                        <div>年</div>
                        <div class="ask-time" :class="{ active: item.date==1 }" @click="itemFun(1,index)">{{item.content[1]}}</div>
                        <div>月</div>
                        <div class="ask-time" :class="{ active: item.date==2 }" @click="itemFun(2,index)">{{item.content[2]}}</div>
                        <div>日</div>
                        <!-- <div class="ask-time" :class="{ active: item.date==3 }" @click="itemFun(3,index)">{{item.content[3]=='00'?'':item.content[3]}}</div>
                        <div>:</div>
                        <div class="ask-time" :class="{ active: item.date==4 }" @click="itemFun(4,index)">{{item.content[4]=='00'?'':item.content[4]}}</div> -->
                    </div>
                      <div class="ask-clavier">
                        <van-number-keyboard :show="true"
                                             :extra-key="item.extra?item.extra:'清空'"
                                             @input="(value)=>problemChange({
                                                key:index,
                                                value:value
                                             })"
                                             @delete="()=>problemChange({
                                                key:index,
                                                value:-1
                                             })"
                        />
                      </div>
                  </div>
                  <div v-else>
                      <div class="ask-option ask-child flex" :class="{noV:item.id!==-1}"  v-if="item.id==-1||item.id==-9">
                        <div class="k-option flex-1" :class="{ active: cont.active }"  v-for="( cont, index1 ) in item.content" v-bind:key="index1" @click="()=>problemChange({
                              key:index,
                              index:index1,
                              value:true
                          })">
                          {{screenFun(cont.label)}}
                        </div>
                      </div>
                      <div v-else class="aho-option" :class="{row2:item.content.length>9}">
                          <div class="ask-option flex" v-for="( cont, index1 ) in item.content" v-bind:key="index1">
                              <div class="k-option flex-1" :class="{ active: cont.active }" @click="()=>problemChange({
                                  key:index,
                                  index:index1,
                                  value:true
                              })">{{screenFun(cont.label)}}</div>
                          </div>
                      </div>
                  </div>
                  <div class="ask-cheak flex flex-x" :class="{ cheak:page<4 }">
                      <div class="prev" v-if="page!==0" @click="()=>pageFun('up')">上一题</div>
                      <div class="next" @click="()=>pageFun('down')">下一题</div>
                      <!-- <div class="next" v-else @click="()=>submit()">提交</div> -->
                  </div>
                  </div>
                  <div v-else class="ask-load flex flex-x flex-y">
                      <div v-if="msg">
                          <div>您提供的信息不足,</div>
                          <div>未匹配到相关病症</div>
                          <div class="ask-again flex flex-x">
                              <div class="again-button" @click="againFun">重新问诊</div>
                          </div>
                      </div>
                      <div v-else>
                          <div class="flex flex-x">
                            <van-loading color="#07b49a" size="48"/>
                          </div>
                          <div class="ask-load-i">正在处理中...</div>
                      </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div v-if="show">
        <vue-popup url="report" :showFun="showFun" :token="token" :callback="callbackFun" />
      </div>
      <div class="loading flex flex-x flex-y" v-if="loading">
        <div class="loading-box">
          <div class="loading-icon">
            <van-loading />
            <div class="loading-ui">提交中</div>
          </div>
        </div>
      </div>
  </div>
</template>
<script>
import vueHeader from '@/components/header';
import { mapState, mapActions, mapMutations } from "vuex";
import vuePopup from "@/components/popup";

export default {
  name: 'question',
  components:{
    vueHeader,
    vuePopup
  },
  created: function () {
    this.questions();    //获取问题
  },
  destroyed: function () {
      this.closeFun();
  },
  computed: {
    date:{
        get() { 
          return this.$store.state.question.problem 
        }
    },
    ...mapState ("question", ["problem","tyle","page","flow_base","show","token","loading","msg"]),
  },
  methods: {
    submit(){             //提交问诊
      this.submitData({_this:this});
    },
    showFun(){
      this.change({
          key:'show',
          value:false
      })
    },
    pageFun(action){
      this.pageChange({
        value:this.page+1,
        action,
        _this:this
      });
    },
    callbackFun(){
      this.$router.push({
          name:'report',
          params: {
              id:this.token
          }
      })
    },
    //重新问诊
    againFun(){
      this.change({key:'problem',value:{ renovate:false, data:[] }});
      this.change({key:'page',value:0});
      this.change({key:'msg',value:false});
      
      this.questions();
    },
    //乳房胀痛
    screenFun(label){
        let data = this.$store.state.question.problem.data[0];
        let sex = 2;
        if(data.id==-1 && data.content[0].active){
            sex = 1;
        }
        if(sex==1 && label=='乳房胀痛'){
            return '胸胀胸痛';
        }else{
            return label;
        }
    },
    itemFun(val,index){
      let problem = this.problem;
      problem.data[index].date = val;
      this.change({
          key:'problem',
          value:{
            renovate:!problem.renovate,
            data:problem.data
          }
      })
    },
    ...mapMutations ("question", ["change","pageChange","questions","problemChange","closeFun"]),
    ...mapActions ("question", ["axiosData","submitData"])
  }
}
</script>
<style lang="scss" scoped rel="stylesheet/scss">
  @import 'question';
</style>